var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgErrorLock = function SvgErrorLock(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 24,
    cy: 24,
    r: 22.4,
    fill: "#F74249",
    stroke: "#F74249",
    strokeWidth: 3.2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.24 19.938v-3.815c0-3.16 2.578-5.723 5.76-5.723 3.18 0 5.76 2.562 5.76 5.723v3.815h1.92c1.06 0 1.92.86 1.92 1.92V33.28c0 1.06-.86 1.92-1.92 1.92H16.32a1.92 1.92 0 0 1-1.92-1.92V21.858c0-1.06.859-1.92 1.92-1.92h1.92Zm8.639 0h-5.76v-3.815a2.87 2.87 0 0 1 2.88-2.862 2.87 2.87 0 0 1 2.88 2.862v3.815Zm.96 7.631c0-2.107-1.733-3.815-3.84-3.815-2.107 0-3.84 1.708-3.84 3.815s1.733 3.816 3.84 3.816c2.107 0 3.84-1.709 3.84-3.816Zm-1.92 0c0 1.054-.86 1.908-1.92 1.908s-1.92-.854-1.92-1.908c0-1.053.86-1.907 1.92-1.907s1.92.854 1.92 1.907Z",
    fill: "white"
  })));
};
export default SvgErrorLock;